import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../../components/Loading/Spinner";
import SingleUserPanel from "../../components/Table/UserControl/SingleUserPanel";
import { useSingleUserControl } from "../../context/SuperAdmin/SingleUserControlContext";

const SingleUserControlPage = () => {
  const { isLoadingUser } = useSingleUserControl();
  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button onClick={() => navigate(-1)} sx={{ color: "#336B87" }}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoadingUser ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <SingleUserPanel />
      )}
    </Grid>
  );
};

export default SingleUserControlPage;
